import s from './ColorPicker.module.scss';

export const DEFAULT_PRESET_COLORS = [
  '#94A3B8',
  '#F87171',
  '#FB923C',
  '#FBBF24',
  '#4ADE80',
  '#34D399',
  '#38BDF8',
  '#818CF8',
  '#E879F9',
  '#F472B6',
];

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
  label?: string;
  hint?: string;
  presetColors?: string[];
}

export function ColorPicker({
  value,
  onChange,
  label = 'Color',
  hint = 'Choose a preset color or pick a custom one.',
  presetColors = DEFAULT_PRESET_COLORS,
}: ColorPickerProps) {
  const isPresetColor = presetColors.includes(value);

  return (
    <div className={s.colorSection}>
      <div className={s.colorLabelRow}>
        <span className={s.colorLabel}>{label}</span>
        <div className={s.colorPreview}>
          <span className={s.previewSwatch} style={{ backgroundColor: value }} aria-hidden />
          <span className={s.previewText}>{value?.toUpperCase()}</span>
        </div>
      </div>
      {hint && <span className={s.colorHint}>{hint}</span>}

      <div className={s.swatchesRow}>
        {presetColors.map((c) => (
          <button
            key={c}
            type="button"
            onClick={() => onChange(c)}
            className={s.swatchButton}
            style={{ backgroundColor: c }}
            aria-label={`Select color ${c}`}
            aria-pressed={value === c}
          />
        ))}
        <label className={s.customColorButton} title="Pick custom color">
          <span className={s.customColorLabel}>Custom</span>
          <span className={s.customColorDot} style={{ backgroundColor: value }} aria-hidden />
          <input
            type="color"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            aria-label="Pick custom color"
            className={s.hiddenColorInput}
          />
        </label>
      </div>

      {!isPresetColor && <span className={s.customColorActive}>Custom color selected</span>}
    </div>
  );
}

export default ColorPicker;
